import { render, staticRenderFns } from "./AddChannel.vue?vue&type=template&id=7e9cc304&"
import script from "./AddChannel.vue?vue&type=script&lang=js&"
export * from "./AddChannel.vue?vue&type=script&lang=js&"
import style0 from "./AddChannel.vue?vue&type=style&index=0&id=7e9cc304&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports